import { render, staticRenderFns } from "./CwcLoading.vue?vue&type=template&id=53eba178"
import script from "./CwcLoading.vue?vue&type=script&lang=js"
export * from "./CwcLoading.vue?vue&type=script&lang=js"
import style0 from "./CwcLoading.vue?vue&type=style&index=0&id=53eba178&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports